module.exports = __webpack_public_path__ + "media/newstyle/images/stars_5-red-638aee77217910512b718059553b2f5a.svg";